const initializeAvorootsDescriptions = (root = document) => {
  root.querySelectorAll('[data-avoroots-description]').forEach((description) => {
    if (description.dataset.avorootsInitialized === 'true') return;

    const content = description.querySelector('[data-avoroots-description-content]');
    const toggle = description.querySelector('[data-avoroots-description-toggle]');

    if (!content || !toggle) return;
    description.dataset.avorootsInitialized = 'true';

    const refreshToggle = () => {
      const isExpanded = description.classList.contains('is-expanded');
      const hasOverflow = isExpanded
        ? description.classList.contains('has-overflow')
        : content.scrollHeight > content.clientHeight + 2;
      const needsToggle = isExpanded || hasOverflow;

      description.classList.toggle('has-overflow', hasOverflow);
      toggle.hidden = !needsToggle;
    };

    toggle.addEventListener('click', () => {
      const isExpanded = description.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(isExpanded));
      toggle.textContent = isExpanded ? 'Menos' : 'Más...';
      refreshToggle();
    });

    refreshToggle();
    window.addEventListener('resize', refreshToggle, { passive: true });
  });
};

const positionAvorootsQuestionsBeforeReviews = (root = document) => {
  root.querySelectorAll('[data-avoroots-questions]').forEach((questions) => {
    if (!questions.querySelector('accordion-tab')) {
      questions.hidden = true;
      return;
    }

    const productSectionId = questions.dataset.avorootsProductSection;

    if (productSectionId) {
      document
        .querySelectorAll(`[data-avoroots-questions][data-avoroots-product-section="${productSectionId}"]`)
        .forEach((candidate) => {
          if (candidate !== questions) candidate.remove();
        });
    }

    const reviewsSection =
      document.querySelector('[id$="__172722638923d0a462"]') ||
      [...document.querySelectorAll('.shopify-section')].find((section) =>
        section.querySelector('.jdgm-widget, [class*="jdgm-review-widget"], [data-id*="judge-me"]')
      );

    if (!reviewsSection || !reviewsSection.parentNode) return;

    questions.classList.add('avoroots-product-v2__questions--before-reviews');
    reviewsSection.parentNode.insertBefore(questions, reviewsSection);
  });
};

const initializeAvorootsProductV2 = (root = document) => {
  initializeAvorootsDescriptions(root);
  positionAvorootsQuestionsBeforeReviews(root);
};

document.addEventListener('DOMContentLoaded', () => initializeAvorootsProductV2());
document.addEventListener('shopify:section:load', (event) => initializeAvorootsProductV2(event.target));
